/* eslint-disable react/prop-types */
import { Stack } from "@mui/material";
import HeaderBreadcrumbs from "../../components/HeaderBreadcrumbs";
import useLocales from "../../hooks/useLocales";
import { PATH_THIGPLX } from "../../routes/paths";

export function SituationExamHeader() {
  const { translate } = useLocales();

  const breadcrumbLinks = [
    { name: translate('menu.home'), href: PATH_THIGPLX.home },
    { name: translate('menu.situation'), href: PATH_THIGPLX.situations },
    { name: translate('situationExam.title') }
  ];

  return (
    <Stack spacing={1}>
      <HeaderBreadcrumbs
        heading={`${translate('situationExam.title')} ${new Date().getMonth() + 1}/${new Date().getFullYear()}`}
        links={breadcrumbLinks}
        subtitle={translate('situationExam.guide')}
      />
    </Stack>
  );
}